export default {
  init: function() {
    console.log('Kadenze.FaqsView initialization function called');
    $('.question > a').click(function(e) {
      var $this = $(this);
      var $question = $this.closest('.question');
      $question.toggleClass('active');
      var dur = 230;
      if ($question.hasClass('active')) {
        $this.attr('aria-expanded', true);
        $('.faq-answer', $question)
          .slideDown(dur, 'easeInOutQuad')
          .animate({
            opacity: 1
          }, {
            queue: false,
            duration: dur + 100
          });
      } else {
        $this.attr('aria-expanded', false);
        $('.faq-answer', $question).slideUp(dur, 'easeInOutQuad', function() {
          $(this).hide().css('opacity', 0);
        });
      }
      e.preventDefault();
    });
  }
};
